export const abarrotesProducts = [
  // Azúcar
  {
    id: 1,
    name: 'Azúcar La Teresita 1 kg',
    image: 'https://public.readdy.ai/ai/img_res/5bd0554c-5b1d-4710-a891-4102f574f49a.png',
    unitsPerPack: 10,
    packagingType: 'Manga',
    unitPrice: 850,
    packPrice: 6500,
    palletPrice: null,
    category: 'Azúcar'
  },
  {
    id: 2,
    name: 'Azúcar Mi Sol 1 kg',
    image: 'https://public.readdy.ai/ai/img_res/82edccdb-4d94-4303-b894-cf333d5f0337.png',
    unitsPerPack: 10,
    packagingType: 'Manga',
    unitPrice: 880,
    packPrice: 6600,
    palletPrice: null,
    category: 'Azúcar'
  },
  {
    id: 3,
    name: 'Azúcar Amelia 1 kg',
    image: 'https://public.readdy.ai/ai/img_res/919fc4d7-a826-4024-aa44-2734bbbbd52d.png',
    unitsPerPack: 10,
    packagingType: 'Manga',
    unitPrice: 790,
    packPrice: 6300,
    palletPrice: null,
    category: 'Azúcar'
  },
  {
    id: 4,
    name: 'Azúcar Iansa 1 kg',
    image: 'https://public.readdy.ai/ai/img_res/a9233a3f-e967-45ae-8f1a-34713170d24d.png',
    unitsPerPack: 20,
    packagingType: 'Manga',
    unitPrice: 1350,
    packPrice: 22000,
    palletPrice: null,
    category: 'Azúcar'
  },
  {
    id: 5,
    name: 'Azúcar Iansa 1.7 kg',
    image: 'https://public.readdy.ai/ai/img_res/8e850733-4f82-44df-94a6-a394e2a68abe.png',
    unitsPerPack: 8,
    packagingType: 'Manga',
    unitPrice: 2200,
    packPrice: 15920,
    palletPrice: null,
    category: 'Azúcar'
  },
  // Arroz
  {
    id: 6,
    name: 'Arroz Miraflores Largo Ancho G1 1 kg',
    image: 'https://public.readdy.ai/ai/img_res/962990f2-05f4-41e7-bef2-c0f9261f5c7a.png',
    unitsPerPack: 10,
    packagingType: 'Manga',
    unitPrice: 2100,
    packPrice: 17900,
    palletPrice: null,
    category: 'Arroz'
  },
  {
    id: 7,
    name: 'Arroz Tucapel G2 900 g',
    image: 'https://public.readdy.ai/ai/img_res/9213525e-655a-4408-931a-762e06cd87c3.png',
    unitsPerPack: 10,
    packagingType: 'Manga',
    unitPrice: 1390,
    packPrice: 12500,
    palletPrice: null,
    category: 'Arroz'
  },
  {
    id: 8,
    name: 'Arroz Bonanza G2 Largo 1 kg',
    image: 'https://public.readdy.ai/ai/img_res/1cba585d-705d-4eb9-94cd-6045d09640b2.png',
    unitsPerPack: 10,
    packagingType: 'Manga',
    unitPrice: 1150,
    packPrice: 10000,
    palletPrice: null,
    category: 'Arroz'
  },
  {
    id: 9,
    name: 'Arroz Teodoro G2 1 kg',
    image: 'https://public.readdy.ai/ai/img_res/ed023dff-dc54-4cc2-9097-959cec91f400.png',
    unitsPerPack: 10,
    packagingType: 'Manga',
    unitPrice: 990,
    packPrice: 6500,
    palletPrice: null,
    category: 'Arroz'
  },
  {
    id: 10,
    name: 'Arroz Mi Sol G2 1 kg',
    image: 'https://public.readdy.ai/ai/img_res/72f0dc63-318a-4a86-8c42-7f6fc702ff48.png',
    unitsPerPack: 10,
    packagingType: 'Manga',
    unitPrice: 990,
    packPrice: 7300,
    palletPrice: null,
    category: 'Arroz'
  },
  // Aceites
  {
    id: 11,
    name: 'Aceite de Oliva VDR 250 ml',
    image: 'https://public.readdy.ai/ai/img_res/ec100a1a-bfdc-473e-a5df-8462300354d1.png',
    unitsPerPack: 24,
    packagingType: 'Caja',
    unitPrice: 2800,
    packPrice: 64080,
    palletPrice: null,
    category: 'Aceites'
  },
  {
    id: 12,
    name: 'Aceite Maravilla Miraflores 900 ml',
    image: 'https://public.readdy.ai/ai/img_res/b231bd64-4fc3-4ebf-a05b-546d1f86d256.png',
    unitsPerPack: 15,
    packagingType: 'Caja',
    unitPrice: 2500,
    packPrice: 29850,
    palletPrice: null,
    category: 'Aceites'
  },
  {
    id: 13,
    name: 'Aceite Vegetal Mi Sol 900 ml',
    image: 'https://public.readdy.ai/ai/img_res/4322bc36-2ab3-4bcf-afdd-16ede4c559b9.png',
    unitsPerPack: 12,
    packagingType: 'Caja',
    unitPrice: 1590,
    packPrice: 16200,
    palletPrice: null,
    category: 'Aceites'
  },
  {
    id: 14,
    name: 'Aceite Vegetal De Reyes 900 ml',
    image: 'https://public.readdy.ai/ai/img_res/58b08966-c97a-4e4c-a0b4-2f08e2c0623b.png',
    unitsPerPack: 12,
    packagingType: 'Caja',
    unitPrice: 1580,
    packPrice: 16140,
    palletPrice: null,
    category: 'Aceites'
  },
  // Sal
  {
    id: 15,
    name: 'Sal Económica 1 kg',
    image: 'https://public.readdy.ai/ai/img_res/4c3259a8503e125d039c661959324901.jpg',
    unitsPerPack: 10,
    packagingType: 'Manga',
    unitPrice: 350,
    packPrice: 2450,
    palletPrice: null,
    category: 'Sal'
  },
  {
    id: 16,
    name: 'Sal Lobos 1 kg',
    image: 'https://public.readdy.ai/ai/img_res/b76eb4bb-6715-443e-88c7-374b2fe6cb57.png',
    unitsPerPack: 10,
    packagingType: 'Manga',
    unitPrice: 580,
    packPrice: 4380,
    palletPrice: null,
    category: 'Sal'
  }
];
